import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var ReviewCharacteristicsQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query ReviewCharacteristicsQuery($productId: ID!) {\n    reviewCharacteristics(reviewRequest: { id: $productId }) {\n      id\n      label\n    }\n  }\n"])));
export default ReviewCharacteristicsQuery;